// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChartRendererDrawingAdvancedParamsEnum, TerceraChartToolRendererDrawingType } from '../../Utils/ChartConstants';
import { LayersEnum } from '../../Utils/LayersEnum';
import { TerceraChartBaseRenderer } from '../TerceraChartBaseRenderer';
/**
 * A class to store indicators in one place.
 */
export class TerceraChartIndicatorStorageRenderer extends TerceraChartBaseRenderer {
    constructor(chart, mainWindow = false) {
        super(chart);
        this.Indicators = [];
        this.assignLayer = LayersEnum.Quotes;
        this.window = null;
        this.mainWindow = mainWindow;
        this.SetClassName('TerceraChartIndicatorStorageRenderer');
    }
    get UseInAutoscale() {
        const window = this.window;
        return window ? window.indicatorRendererSettings.UseInAutoscale : false;
    }
    set UseInAutoscale(value) {
        this.UseInAutoscale = value;
        const window = this.window;
        if (window)
            window.indicatorRendererSettings.UseInAutoscale = value;
    }
    Draw(gr, window, windowsContainer, advParams = null) {
        if (window !== this.window)
            this.window = window;
        const param = advParams;
        let curDrawing = TerceraChartToolRendererDrawingType.Foreground;
        if (param.Tag[TerceraChartRendererDrawingAdvancedParamsEnum.CurrentDrawingType] !== undefined) {
            curDrawing = param.Tag[TerceraChartRendererDrawingAdvancedParamsEnum.CurrentDrawingType];
        }
        const ql = advParams.layerId === LayersEnum.Quotes;
        for (let i = 0; i < this.Indicators.length; i++) {
            const indRenderer = this.Indicators[i];
            if (this.mainWindow &&
                ((!indRenderer.OnTop && curDrawing == TerceraChartToolRendererDrawingType.Foreground) ||
                    (indRenderer.OnTop && curDrawing == TerceraChartToolRendererDrawingType.Background))) {
                continue;
            }
            if (this.mainWindow && !indRenderer.OnTop && ql)
                continue;
            if (this.mainWindow && indRenderer.OnTop && !ql)
                continue;
            indRenderer.Draw(gr, window, windowsContainer, advParams);
        }
    }
    FindMinMax(out_minMax, window) {
        let result = true;
        out_minMax.tMin = Number.MAX_VALUE;
        out_minMax.tMax = -Number.MAX_VALUE;
        for (let i = 0; i < this.Indicators.length; i++) {
            const renderer = this.Indicators[i];
            const minMaxObj = { tMin: Number.MAX_VALUE, tMax: -Number.MAX_VALUE };
            if (!renderer.InvalidState && renderer.FindMinMax(minMaxObj, window)) {
                result = true;
                if (minMaxObj.tMin < out_minMax.tMin)
                    out_minMax.tMin = minMaxObj.tMin;
                if (minMaxObj.tMax > out_minMax.tMax)
                    out_minMax.tMax = minMaxObj.tMax;
            }
        }
        return result;
    }
    Dispose() {
        this.chart = null;
        super.Dispose();
    }
    ProcessMouseMove(e) {
        const results = this.Indicators.map((indicator) => indicator.ProcessMouseMove(e));
        if (results.some((result) => result)) {
            e.NeedRedraw = true;
        }
        return false;
    }
}
